import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

function baseStyleContent(props: StyleFunctionProps) {
  return {
    bg: mode('white', 'gray.700')(props),
    border: '1px solid',
    borderColor: 'inherit',
    borderRadius: 'md',
    boxShadow: 'sm',
    zIndex: 'inherit',
    _focus: {
      outline: 0,
      boxShadow: 'none',
    },
  };
}

const baseStyle = (props: StyleFunctionProps) => ({
  content: baseStyleContent(props),
});

export default {
  baseStyle,
};
